import ImageUtil from '@/js/util/ImageUtil.js'
import TexturePacker from '@/lib/TexturePacker.js'
import IconCluster from '@/assets/ifield/cluster-checkin@3x.png'
import IconClusterSelected from '@/assets/ifield/cluster-checkin-selected@3x.png'
import IconPin from '@/assets/ifield/checkin-pin@3x.png'

// mapping
const MAPPING = {
  default: {
    x: 0,
    y: 0,
    width: 168,
    height: 192,
    anchorX: 84,
    anchorY: 168,
  },
  cluster: {
    x: 0,
    y: 0,
    width: 288,
    height: 192,
    anchorX: 144,
    anchorY: 96,
  },
  clusterSelected: {
    x: 0,
    y: 0,
    width: 288,
    height: 192,
    anchorX: 144,
    anchorY: 96,
  },
}

/**
 * チェックインマーカー保持Vuexモジュール
 */
export default {
  namespaced: true,
  state: {
    imageStore: new Map(), // ユーザピン画像のstore
    iconAtlas: null,
    iconMapping: null,
  },
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      state.imageStore.clear()
      state.iconAtlas = null
      state.iconMapping = null
    },
    /**
     * 画像をストア
     * @param {*} state
     * @param {String} id ユーザID
     * @param {String} image 画像データ
     */
    setImage(state, { id, image }) {
      if (image) {
        state.imageStore.set(id, image)
      }
    },
    /**
     * iconAtlas更新
     * @param {*} state
     * @param {ImageBitmap} atlas
     */
    setAtlas(state, atlas) {
      state.iconAtlas = atlas
    },
    /**
     * iconMapping更新
     * @param {*} state
     * @param {Object} mapping
     */
    setMapping(state, mapping) {
      state.iconMapping = mapping
    },
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * state初期化
     * @param {Boolean} force 強制的に初期化する場合はtrue
     * @returns {Promise.<Object>} 初期化後の{atlas, mapping}
     */
    async initializeState({ state, commit, dispatch }, force) {
      if (!force && state.iconAtlas && state.iconMapping) {
        // 既に存在しているのでそのまま返却
        return { atlas: state.iconAtlas, mapping: state.iconMapping }
      }

      // imageStoreにデフォルト使用マーカー登録
      const [pin, cluster, clusterSelected] = await Promise.all([
        ImageUtil.toImage(IconPin),
        ImageUtil.toImage(IconCluster),
        ImageUtil.toImage(IconClusterSelected),
      ])
      commit('setImage', { id: 'default', image: ImageUtil.toDataURL(pin) })
      commit('setImage', { id: 'cluster', image: ImageUtil.toDataURL(cluster) })
      commit('setImage', {
        id: 'clusterSelected',
        image: ImageUtil.toDataURL(clusterSelected),
      })

      // texture作成
      return await dispatch('updateTexture')
    },
    /**
     * texture state 更新
     * @returns {Promise.<Object>} 更新後の{atlas, mapping}
     */
    async updateTexture({ commit, state }) {
      const images = await Promise.all(
        [...state.imageStore.entries()].map(async ([id, image]) => ({
          id,
          atlas: await ImageUtil.toImage(image),
          mapping: MAPPING[id] || MAPPING.default,
        }))
      )

      const packer = new TexturePacker()
      const { atlas, mapping } = await packer.pack(images)
      commit('setAtlas', atlas)
      commit('setMapping', mapping)

      return { atlas, mapping }
    },
    /**
     * 指定IDのマーカー画像取得
     * @param {Number} id マーカーID
     */
    getImageById({ state }, id) {
      return state.imageStore.get(id)
    },
  },
}
